import { Alert, Box, Button, Card, Grid, Typography } from "@mui/material";
import { useAppSelector } from "../app/hooks";
import { selectLoggedInUser } from "../features/auth/auth.slice";
import { useNavigate } from "react-router-dom";
import useActiveWorkoutPlan from "../hooks/use-active-workout-plan";
import WorkoutPlanMemberView from "../features/workout/workout-plan/components/workout-plan-member-view";
import { isMember } from "../helpers/user-helpers";

const MemberWorkout = () => {
    const navigate = useNavigate();
    const loggedInUser = useAppSelector(selectLoggedInUser);
    const activePlan = useActiveWorkoutPlan(loggedInUser?.roleData.member?.id ?? 0);

    return (
        <div>
            {isMember(loggedInUser) &&
                <>
                    {activePlan?.id ? (
                        <>
                            <Box display="flex" justifyContent="flex-end" sx={{ mb: 2 }}>
                                <Button variant="contained" color="primary" onClick={() => { navigate(`/members/${loggedInUser?.roleData.member?.id}/workout-plan`) }}>Edit Plan</Button>
                            </Box>
                            <Grid size={{ xs: 12, md: 6 }} justifyContent="center" alignItems="center" spacing={2} sx={{ display: 'flex', width: '100%', mb: 2 }}>
                                <Card sx={{ p: 2, justifyContent: 'center', alignItems: 'center', gap: 2, justifySelf: 'center', display: 'flex', flexDirection: 'column' }}>
                                    <Typography variant="body2">{`Plan Start Date: ${activePlan?.startDate ?? "N/A"} `}</Typography>
                                    <Typography variant="body2">{`Plan End Date: ${activePlan?.endDate ?? "N/A"} `}</Typography>
                                </Card>
                            </Grid>
                            <Grid container direction="row" justifyContent="flex-start" spacing={2}>
                                <WorkoutPlanMemberView workoutPlan={activePlan} />
                            </Grid>
                        </>
                    ) : (
                        <>
                            <Alert severity="info" variant="filled" sx={{ width: 'fit-content', mb: 2, justifyContent: 'center' }}>
                                You do not have an active workout plan. Please create a new plan and add exercises.
                            </Alert>

                            <Box display="flex" sx={{ mb: 2 }}>
                                <Button variant="contained" color="primary" onClick={() => { navigate(`/members/${loggedInUser?.roleData.member?.id}/workout-plan`) }}>Create Plan</Button>
                            </Box>
                        </>
                    )}
                </>
            }
        </div>
    )
}

export default MemberWorkout;